module.exports = __webpack_public_path__ + "static/media/1-1.82aab8c4.png";